// 覚醒王の「顔を見せる間合い」の比較版 (DEV `?awokenFaceRoom=1`・2026-10-27)。既定 (指定なし) = 配布版のまま = 何もしない。
//   作者 (10-27)「戦闘距離が近い＋攻撃のたびに前進しているせいで、攻撃の予備動作の時に見るべき顔の先のあたりがLUNAIREと被っていて見えにくい」。
//   実測 (scripts/capture_awoken_face_overlap_1027.mjs・配布版で90秒×2): 技に入る距離はほぼ 90〜110px。暴噛の予備動作では
//   顔の点が主人公の中心を 14〜35px 越え、予備動作の 90〜100% の間、顔が主人公の頭に重なっていた。
//   比較版: 待機の間に主人公が FACE_ROOM_PX − SLACK より近くにいたら、1回だけ歩いて下がって FACE_ROOM_PX まで離れてから技に入る
//   (懐で噛まない時と同じ後ろ歩き・src/awoken_spacing_choice.ts)。噛みの踏み込みは口が主人公に重なる所で止まるので、
//   下がっても噛みは口で当たる。
// 暴噛の予備動作で顔は boss.x から前へ 112〜125px。主人公の体の半幅 + 顔の大きさで約 40px 手前に顔があれば重ならない。
export const AWOKEN_FACE_ROOM_PX = 165
// 下がる量がこれより小さい時は下がらない (数px の後ろ歩きはちらつく)。
export const AWOKEN_FACE_ROOM_SLACK_PX = 20

let enabled = false
/** DEV の切り替え (game.ts)。'1' = 比較版。 */
export function setAwokenFaceRoom(v: string | null): boolean { enabled = v === '1'; return enabled }
/** 比較版の時だけ、下がって取る距離。配布版は undefined。 */
export function awokenFaceRoomPx(): number | undefined { return enabled ? AWOKEN_FACE_ROOM_PX : undefined }
